import { RichRelevanceConsent } from "../../RecoConsent";

export default class RichRelevanceTracking {
  private static RECO_TRACKING_KEY = "entd-tracking-param";

  static richRelevanceClickTracking(recoTrackingParam: string): void {
    try {
      sessionStorage.setItem(
        RichRelevanceTracking.RECO_TRACKING_KEY,
        recoTrackingParam,
      );
      // eslint-disable-next-line no-empty
    } catch (_) {}
  }

  static sendTrackingInfo(
    richRelevanceConsent: RichRelevanceConsent,
    countryPrefix: string,
    origin: string,
  ): void {
    try {
      const params = sessionStorage.getItem(
        RichRelevanceTracking.RECO_TRACKING_KEY,
      );
      if (params) {
        sessionStorage.removeItem(RichRelevanceTracking.RECO_TRACKING_KEY);

        const urlSearchParams = new URLSearchParams();
        urlSearchParams.append("entd_consent", `${richRelevanceConsent}`);
        urlSearchParams.append("p", encodeURIComponent(params));

        const path = countryPrefix + "/entd/frontend-recommendations/click";
        const url = new URL(path, origin);
        url.search = urlSearchParams.toString();
        void fetch(url.toString(), {
          method: "GET",
        });
      }
      // eslint-disable-next-line no-empty
    } catch (_) {}
  }
}
